import React from 'react';
import classnames from 'classnames';
import { _ as _baseEach, a as _baseIteratee, g as get } from './_baseEach-BIZoFHfR.js';
import { g as getDefaultExportFromCjs } from './_commonjsHelpers-BlEkfD1Z.js';
import { _ as _baseAssignValue } from './_baseAssignValue-rb-8kOMF.js';
import { b as isArray_1 } from './_getTag-CzJuSXVi.js';
import { I as Icon } from './Icon-8KKXFsxm.js';
import { T as Text } from './Text-BCmEgJBp.js';
import { H as Heading } from './Heading-DX1jjqTV.js';
import { T as Typography } from './Typography-BUVIUAC9.js';
import { M as Markdown } from './Markdown-BZlKvsyD.js';
import { E as Emphasis } from './Emphasis-CnMqEBsf.js';

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */

function arrayAggregator$1(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

var _arrayAggregator = arrayAggregator$1;

var baseEach = _baseEach;

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator$1(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

var _baseAggregator = baseAggregator$1;

var arrayAggregator = _arrayAggregator,
    baseAggregator = _baseAggregator,
    baseIteratee = _baseIteratee,
    isArray = isArray_1;

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator$1(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee), accumulator);
  };
}

var _createAggregator = createAggregator$1;

var baseAssignValue = _baseAssignValue,
    createAggregator = _createAggregator;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

var groupBy_1 = groupBy;

var groupBy$1 = /*@__PURE__*/getDefaultExportFromCjs(groupBy_1);

var styles$1 = {"list":"u853Ql4cj50-","item":"ig9l6LfEgwo-","section":"KIYTQdrufzY-"};

var sectionStyles = {"sectionHeader":"LUlooG82UJA-","greyBlue":"_4LVpgNq-SLM-","green":"_0QhWokyE9PY-","blue":"J8wB3qqOlBc-","archived":"Ujqj17pKDIE-","orange":"_0lNxLGXhrfY-","red":"_4qPymF0CAAE-","teal":"kKYNLBSu9IQ-"};

var styles = {"action":"XPLf4Jp6feU-","hoverable":"RseHYbVm4MA-","icon":"d1-zQvxPH-M-","info":"_-58VuZf1TtM-","amount":"wHB5zXYWW3E-","isActive":"C4DznaxLKiw-","truncate":"Brob-IpVv4o-"};

function ListItem({ caption, content, icon, iconColor, id, isActive, onClick, title, url, value, }) {
    const actionClasses = classnames(styles.action, isActive && styles.isActive, (onClick || url) && styles.hoverable);
    const Wrapper = url ? "a" : "button";
    const buttonProps = Object.assign({}, (Wrapper === "button" && { role: "button", type: "button" }));
    return (React.createElement(Wrapper, Object.assign({ id: id.toString(), className: actionClasses, href: url, onClick: onClick }, buttonProps),
        icon && (React.createElement("div", { className: styles.icon },
            React.createElement(Icon, { name: icon, color: iconColor }))),
        React.createElement("div", { className: styles.info },
            title && React.createElement(Heading, { level: 5 }, title),
            React.createElement(Description, { content: content }),
            caption && (React.createElement(Text, { variation: "subdued" },
                React.createElement(Typography, { element: "span", size: "small", emphasisType: "italic" }, caption)))),
        value && (React.createElement("div", { className: styles.amount },
            React.createElement(Text, null,
                React.createElement(Emphasis, { variation: "bold" }, value))))));
}
function Description({ content }) {
    if (content instanceof Array) {
        return (React.createElement(React.Fragment, null, content.map((item, i) => (React.createElement(Text, { key: i },
            React.createElement("span", { className: styles.truncate },
                React.createElement(Markdown, { content: item, basicUsage: true })))))));
    }
    else {
        return (React.createElement(Text, null,
            React.createElement("span", { className: styles.truncate },
                React.createElement(Markdown, { content: content, basicUsage: true }))));
    }
}

function List({ items }) {
    const isSectioned = items.some(item => item.section);
    if (isSectioned) {
        return React.createElement(SectionedList, { items: items });
    }
    else {
        return React.createElement(DisplayList, { items: items });
    }
}
function DisplayList({ items }) {
    return (React.createElement("ul", { className: styles$1.list }, items.map(item => (React.createElement("li", { key: item.id, className: styles$1.item },
        React.createElement(ListItem, Object.assign({}, item)))))));
}
function SectionedList({ items }) {
    const sectionedItems = groupBy$1(items, item => get(item, "section", "Other"));
    const sectionHeaderClassNames = classnames(sectionStyles.sectionHeader);
    return (React.createElement("ul", { className: styles$1.list }, Object.keys(sectionedItems).map(sectionName => (React.createElement("li", { key: sectionName, className: styles$1.section },
        React.createElement("div", { className: sectionHeaderClassNames },
            React.createElement(Typography, { element: "h4", fontWeight: "bold", size: "large" }, sectionName)),
        React.createElement("ul", { className: styles$1.list }, sectionedItems[sectionName].map(item => (React.createElement("li", { key: item.id, className: styles$1.item },
            React.createElement(ListItem, Object.assign({}, item)))))))))));
}

export { List as L, ListItem as a };
